import { makeObservable, observable, action } from 'mobx';
import API from 'src/api/API';
import { isAdminToken, isUserToken } from 'src/util';
import { clearPendingLoginOtp } from './LoginOtpSession';

export class AuthStore {
  @observable isAuthenticated = false;
  @observable isUserFlow = false;
  @observable isAdminFlow = false;

  constructor() {
    makeObservable(this);
    this.checkAuth();
  }

  @action
  login(token: string) {
    localStorage.setItem('jwtToken', token);
    this.isAuthenticated = true;
    // Check token type immediately after login
    this.checkTokenType();
  }

  @action
  checkTokenType() {
    // Update token type flags
    this.isAdminFlow = isAdminToken();
    this.isUserFlow = isUserToken();
  }

  @action
  logout(clearPendingLogin: boolean = true) {
    localStorage.removeItem('jwtToken');
    if (clearPendingLogin) {
      clearPendingLoginOtp();
    }
    this.isAuthenticated = false;
    this.isAdminFlow = false;
    this.isUserFlow = false;
  }

  @action
  checkAuth() {
    this.isAuthenticated = !!localStorage.getItem('jwtToken');
    if (this.isAuthenticated) {
      this.checkTokenType();
    }
  }
}
